// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-right-double-s"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.50195 8.46448L11.0375 12L7.50195 15.5355M12.9629 8.46448L16.4984 12L12.9629 15.5355","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronRightDoubleSIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-right-double-s',
    ref,
    icon: element,
  },
));

ChevronRightDoubleSIcon.displayName = 'ChevronRightDoubleSIcon';

export default ChevronRightDoubleSIcon;
